import { useTranslation } from "next-i18next";
import Image from "next/image";

const MaxPerformanceWebSiteCloudServer = () => {
    const { t } = useTranslation(["common", "cloudServer"]);

    return (
        <div className="container px-4 py-12 mx-auto lg:py-24">
            <h2 className="relative z-10 text-3xl font-semibold text-center text-titleColor text-after-shadow-cloud5 lg:text-4xl">{t("cloudServer:maxPerformanceWebSiteCloudServer")}</h2>
            <div className="pt-8 text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:maxPerformanceWebSiteCloudServerDesc") }}></div>

            <div className="grid items-center pt-8 lg:grid-cols-2">
                <div>
                    <Image src={"/betweenDifferencesWebHostingCloudServer.png"} width={414} height={392} alt={t("cloudServer:maxPerformanceWebSiteCloudServer")} title={t("cloudServer:maxPerformanceWebSiteCloudServer")} />
                </div>

                <div>
                    <h3 className="my-4 text-2xl font-bold text-titleColor lg:text-3xl">{t("cloudServer:betweenDifferencesWebHostingCloudServer")}</h3>
                    <div className=" text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:betweenDifferencesWebHostingCloudServerDesc") }}></div>

                    <p className="pt-4 font-medium text-textGray">{t("cloudServer:betweenDifferencesWebHostingCloudServerDesc2")}</p>

                    <p className="pt-4 font-medium text-textGray">{t("cloudServer:betweenDifferencesWebHostingCloudServerDesc3")}</p>

                    <p className="pt-4 font-medium text-textGray">{t("cloudServer:betweenDifferencesWebHostingCloudServerDesc4")}</p>

                    <p className="pt-4 font-medium text-textGray">{t("cloudServer:betweenDifferencesWebHostingCloudServerDesc5")}</p>

                    <p className="pt-4 font-medium text-textGray">{t("cloudServer:betweenDifferencesWebHostingCloudServerDesc6")}</p>

                    <div className="flex ">
                        <div className="mt-4">🚀</div> <div className="pt-4 font-medium text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:betweenDifferencesWebHostingCloudServerDesc7") }}></div>
                    </div>
                </div>
            </div>

            <div className="grid items-center pt-16 lg:grid-cols-2">
                <div>
                    <h3 className="my-4 text-2xl font-bold text-titleColor lg:text-3xl">{t("cloudServer:advantagesOfCloudSererForHighTrafficSites")}</h3>
                    <div className=" text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:advantagesOfCloudSererForHighTrafficSitesDesc") }}></div>

                    <div className="flex items-center justify-center space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                        <p className="pt-4 font-medium text-textGray">{t("cloudServer:advantagesOfCloudSererForHighTrafficSitesDesc2")}</p>
                    </div>

                    <div className="flex items-center justify-center space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                        <p className="pt-4 font-medium text-textGray">{t("cloudServer:advantagesOfCloudSererForHighTrafficSitesDesc3")}</p>
                    </div>

                    <div className="flex items-center justify-center space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                        <p className="pt-4 font-medium text-textGray">{t("cloudServer:advantagesOfCloudSererForHighTrafficSitesDesc4")}</p>
                    </div>

                    <div className="flex items-center justify-center space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                        <p className="pt-4 font-medium text-textGray">{t("cloudServer:advantagesOfCloudSererForHighTrafficSitesDesc5")}</p>
                    </div>

                    <div className="flex items-center justify-center space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                        <p className="pt-4 font-medium text-textGray">{t("cloudServer:advantagesOfCloudSererForHighTrafficSitesDesc6")}</p>
                    </div>

                    <div className="flex">
                        <div className="mt-4 mr-2">📈</div><div className="pt-4 text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:advantagesOfCloudSererForHighTrafficSitesDesc7") }}></div>
                    </div>
                </div>

                <div className="flex justify-end">
                    <Image src={"/advantagesOfCloudServer.png"} width={494} height={502} alt={t("cloudServer:advantagesOfCloudSererForHighTrafficSites")} title={t("cloudServer:advantagesOfCloudSererForHighTrafficSites")} />
                </div>
            </div >

            <div className="grid items-center pt-16 lg:grid-cols-2">
                <div className="order-2 lg:order-1">
                    <Image src={"/seoFriendlyHostinngCloudServer.png"} width={428} height={392} alt={t("cloudServer:seoFriendlyHostinngCloudServer")} title={t("cloudServer:seoFriendlyHostinngCloudServer")} />
                </div>

                <div className="order-1 lg:order-2">
                    <h3 className="my-4 text-2xl font-bold text-titleColor lg:text-3xl">{t("cloudServer:seoFriendlyHostinngCloudServer")}</h3>
                    <div className=" text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:seoFriendlyHostinngCloudServerDesc") }}></div>

                    <div className="flex items-center justify-center space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                        <p className="pt-4 font-medium text-textGray">{t("cloudServer:seoFriendlyHostinngCloudServerDesc2")}</p>
                    </div>

                    <div className="flex items-center justify-center space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                        <p className="pt-4 font-medium text-textGray">{t("cloudServer:seoFriendlyHostinngCloudServerDesc3")}</p>
                    </div>

                    <div className="flex items-center justify-center space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                        <p className="pt-4 font-medium text-textGray">{t("cloudServer:seoFriendlyHostinngCloudServerDesc4")}</p>
                    </div>

                    <div className="flex items-center justify-center space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                        <div className="pt-4 font-medium text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:seoFriendlyHostinngCloudServerDesc5") }}></div>
                    </div>

                    <div className="flex items-center justify-center space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                        <div className="pt-4 font-medium text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:seoFriendlyHostinngCloudServerDesc6") }}></div>
                    </div>

                    <div className="flex">
                        <div className="pr-2 mt-4">📌</div> <div className="pt-4 text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:seoFriendlyHostinngCloudServerDesc7") }}></div>
                    </div>
                </div>
            </div>

            <div className="grid items-center pt-16 lg:grid-cols-2">
                <div>
                    <h3 className="my-4 text-2xl font-bold text-titleColor lg:text-3xl">{t("cloudServer:powerUpYourWebsiteWithCloudServer")}</h3>

                    <div className="flex items-center justify-center pt-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                        <div className="font-medium text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:powerUpYourWebsiteWithCloudServerDesc") }}></div>
                    </div>

                    <div className="flex items-center pt-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                        <p className="font-medium text-textGray">{t("cloudServer:powerUpYourWebsiteWithCloudServerDesc2")}</p>
                    </div>

                    <div className="flex items-center pt-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                        <p className="font-medium text-textGray">{t("cloudServer:powerUpYourWebsiteWithCloudServerDesc3")}</p>
                    </div>

                    <div className="flex items-center pt-4 space-x-2">
                        <i className="p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"></i>
                        <div className="font-medium text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:powerUpYourWebsiteWithCloudServerDesc4") }}></div>
                    </div>

                    <div className="flex">
                        <div className="pr-2 mt-4">🚀</div><div className="pt-4 text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:powerUpYourWebsiteWithCloudServerDesc5") }}></div>
                    </div>
                </div>

                <div className="flex justify-end">
                    <Image src={"/powerUpYourWebsiteCloudHosting.png"} width={420} height={428} alt={t("cloudServer:powerUpYourWebsiteWithCloudServer")} title={t("cloudServer:powerUpYourWebsiteWithCloudServer")} />
                </div>
            </div>
        </div >
    )
}

export default MaxPerformanceWebSiteCloudServer